export default __webpack_public_path__ + "media/projects/purple2-thumb-0f7fffb1.svg";